import { render, staticRenderFns } from "./uploadIcon.vue?vue&type=template&id=9856d7b8&scoped=true"
import script from "./uploadIcon.vue?vue&type=script&lang=js"
export * from "./uploadIcon.vue?vue&type=script&lang=js"
import style0 from "./uploadIcon.vue?vue&type=style&index=0&id=9856d7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9856d7b8",
  null
  
)

export default component.exports